<template>
   <div class="about-wrap">
       <div class="tab-wrapper">
          <button
             v-for="tab in tabs"
             v-bind:key="tab.key"
             v-bind:class="['tab-button', { active: currentTab === tab.key }]"
             v-on:click="currentTab = tab.key"
             class="story-button">
             <span v-html="tab.name"></span>
          </button>
       </div>
      <component v-bind:is="currentTabComponent"></component>
   </div>
</template>

<script>
   // コンポーネントBをインポート
  import tab1960 from '@/components/tab1960';
  import tab1970 from '@/components/tab1970';
  import tab1980 from '@/components/tab1980';
  import tab1990 from '@/components/tab1990';
  import tab2000 from '@/components/tab2000';
  import tab2010 from '@/components/tab2010';
  import Mixin from '@/mixins/mixin.js';
    export default {
       data() {
         return {
            currentTab: '1960',
            tabs: [
              {
                 key: '1960',
                 name: '1961-1970<span class="story-button__period">黎明期</span>'
              },
              {
                 key: '1970',
                 name: '1971-1980<span class="story-button__period">発展期</span>'
              },
              {
                 key: '1980',
                 name: '1981-1990<span class="story-button__period">隆盛期</span>'
              },
              {
                 key: '1990',
                 name: '1991-2000<span class="story-button__period">黄金期</span>'
              },
              {
                 key: '2000',
                 name: '2000-2010<span class="story-button__period">成熟期</span>'
              },
              {
                 key: '2010',
                 name: '2011-2021<span class="story-button__period">現在へ</span>'
              }
            ]
         }
      },
      mixins: [Mixin],
      components: {
         'tab-1960': tab1960,
         'tab-1970': tab1970,
         'tab-1980': tab1980,
         'tab-1990': tab1990,
         'tab-2000': tab2000,
         'tab-2010': tab2010,
      },
    }
</script>

<style lang="scss">

.tab-page {
  border: 1px solid #ccc;
  padding: 10px;
}
.tab-wrapper {
    margin: 30px 0;
    display: flex;
    align-items: center;
    width: 100%;
    .story-button{
        font-family: 'Barlow Condensed', sans-serif;
        font-size: 30px;
        padding: 10px 25px;
        background: #b1b1b1;
        color: #ffffff;
        position: relative;
        width: 16.66%;
        min-width: 170px;
        border: none;
        &__period {
            font-family: "游明朝体", "Yu Mincho", YuMincho, "ヒラギノ明朝 Pro", "Hiragino Mincho Pro", "MS P明朝", "MS PMincho", serif;
            display: block;
            font-size: 20px;
            font-weight: bold;
        }
        &:before{
            content: "";
            position: absolute;
            right: -20px;
            top: -1px;
            left: initial;
            width: 0px;
            height: 0px;
            margin: auto;
            border-style: solid;
            border-color: transparent transparent transparent #ddd;
            border-width: 44px 0 44px 20px;
            z-index: 1;
        }
        &:after{
            content: "";
            position: absolute;
            right: -18px;
            top: 0;
            left: initial;
            width: 0px;
            height: 0px;
            margin: auto;
            border-style: solid;
            border-color: transparent transparent transparent #B1B1B1;
            border-width: 43px 0px 43px 20px;
            z-index: 1;
        }
        &:last-child{
            &:before{
                content: none;
            }
            &:after{
                content: none;
            }
        }
        &.active {
            background: #CB0010;
            &:after{
                border-color: transparent transparent transparent #CB0010;
            }
        }
        &:hover {
            background: #CB0010;
            &:after {
                border-color: transparent transparent transparent #CB0010;
            }
        }
    }
}
.about-title{
  font-family: "游明朝体", "Yu Mincho", YuMincho, "ヒラギノ明朝 Pro", "Hiragino Mincho Pro", "MS P明朝", "MS PMincho", serif;
  font-size: 60px;
  padding: 0 40px;
  margin: 50px auto 40px;
  max-width: 1200px;
  &__year{
      font-family: 'Barlow Condensed', sans-serif;
    font-size: 50px;
    margin-left: 10px;
  }
}
h3 {
    font-family: "游明朝体", "Yu Mincho", YuMincho, "ヒラギノ明朝 Pro", "Hiragino Mincho Pro", "MS P明朝", "MS PMincho", serif;
    font-size: 30px;
    font-weight: bold;
    margin: 0 0 25px;
}
.section {
    max-width: 1200px;
    padding: 0 40px;
    margin: 20px auto;
}
img {
    max-width: 100%;
    height: auto;
}
figcaption {
    font-size: 12px;
    margin-top: 10px;
  }
.img-content {
    padding: 40px;
    padding: 0!important;
    &__bg{
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 60px 40px;
    }
    &__wrap{
      display: flex;
      flex-wrap: wrap;
      max-width: 1200px;
      margin: 0 auto;
    }
    &__text{
      margin-right: 30px;
      width: calc(100% - 530px);
    }
    @media (max-width: 1200px) {
        &__wrap{
            display: block;
        }
        &__text{
            width: 100%;
            margin-bottom: 20px;
        }
    }
}

@media(max-width: 1300px) {
    .tab-wrapper {
        overflow-x: auto;
        overflow-y: hidden;
        .story-button{
            font-size: 1.7rem;
            &__period {
                font-size: 1.1rem;
            }
        }
    }
}
@media(max-width:1023px){
    .tab-wrapper{
        margin-top: 60px;
        .story-button{
            padding: 0px 25px;
            &:before{
                border-width: 34px 0 34px 20px;
            }
            &:after{
                border-width: 33px 0px 33px 20px;
            }
        }
    }
    .about-title{
        font-size: 40px;
        margin: 50px auto 20px;
        padding: 0 20px;
        &__year{
            font-size: 30px;
        }
    }
    .section{
        padding: 3px 20px;
    }
    h3{
        font-size: 24px;
        margin-bottom: 10px;
    }
    figure {
        box-sizing: border-box;
    }
    .img-content__bg{
        display: block;
    }
    .column{
        display: block;
        > *{
            width: 100%;
        }
    }
}
</style>